
const GroupConfigurationTabEnum = {
    GROUP_CONFIGURATION : 'GROUP_CONFIGURATION',
    EMPLOYEE_ALLOCATION :'EMPLOYEE_ALLOCATION',
    ASSIGNMENT_CONFIGURATION :'ASSIGNMENT_CONFIGURATION'
}

Object.freeze(GroupConfigurationTabEnum);

export default GroupConfigurationTabEnum;